import {ExtraFormController as controller} from './controller.js';
import templateUrl from './template.html';

export const extraFieldsComponent = {
    templateUrl: templateUrl,
    controller: controller,
    bindings: {
        // pass in the extra fields
        extra: '<',
        // pass in the passthrough
        passthrough: '<',
        // pass in a reference to the form form the parent for validation.
        form: '=',
    }
};

export default extraFieldsComponent;



// WEBPACK FOOTER //
// ./app/jangl/extra-fields/component.js